import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'


export const FactoryWeightPointListing = ({ factoryWeightPointFilteringData, handleClick, editEnabled}) => {

    const [factoryWeightPointFiltering, setFactoryWeightPointFiltering] = useState([]);

    const contentRowNames = ["collectionPointCode", "collectionPointName", "isActive"]

    useEffect(() => {
        trackPromise(
            setFactoryWeightPointFilteringData()
            )
    }, [factoryWeightPointFilteringData]);

    async function setFactoryWeightPointFilteringData() { 
        destroyDataTable();
        await setFactoryWeightPointFiltering(factoryWeightPointFilteringData);
        createDataTable();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? 
                (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
                :<td key={index}>{da[row] + " "}</td>
            )
         )
    });

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="table-responsive row-top-gap">
                        <table id="example" className="display dataTable no-footer">
                            <thead>
                                <tr>
                                    <th>Weight Point Code</th>
                                    <th>Weight Point Name</th>
                                    <th>Status</th>
                                    {editEnabled ? <th>Action</th> : null}
                                </tr>
                            </thead>
                            <tbody>
                                {factoryWeightPointFiltering.map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            {content(data)}
                                            {editEnabled ? <td 
                                                onClick={() => handleClick(data)} 
                                                style={{cursor: "pointer"}}>
                                                <i class="far fa-edit"></i>
                                            </td> : null}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


